// extracted by mini-css-extract-plugin
export default {"container":"style_container__3LSVc","information":"style_information__1eb8j","dateWrapper":"style_dateWrapper__fMeBX","field":"style_field__CUpDV"};